import React, { useState, useEffect } from "react";
import { Input, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import GetImage from "../../../components/getimage/Getimage";
import attendeesimg from "../../../assets/teammeeting.png";

export default function Step3({ formData, setFormData, attendessarr, userid}) {
  const [employees, setEmployees] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selectedMap, setSelectedMap] = useState({});
  const [search, setSearch] = useState("");

useEffect(() => {
  if (!attendessarr) return;

  const normalized = attendessarr.map((emp) => ({
    value: emp?.empid,
    label: `${emp?.firstname} ${emp?.lastname}`,
  }));

  normalized.sort((a, b) =>
    a.value == userid ? -1 : b.value == userid ? 1 : 0
  );

  setEmployees(normalized);
  setFiltered(normalized);

  let selectedIds = [];

  if (formData.attendees) {
    selectedIds = formData.attendees.split(",").map((id) => Number(id));
  } else {
    selectedIds = [userid];
  }

  const defaultMap = {};
  selectedIds.forEach((id) => {
    defaultMap[id] = true;
  });

  setSelectedMap(defaultMap);

  setFormData((prev) => ({
    ...prev,
    attendees: selectedIds.join(","),
  }));

}, [attendessarr, userid]);
  const storeSearch = (e) => {
    const value = e.target.value;
    setSearch(value);

    if (!value) {
      setFiltered(employees);
    } else {
      const f = employees.filter((emp) =>
        emp.label.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(f);
    }
  };

 
  const toggleEmployee = (emp) => {
    setSelectedMap((prev) => ({
      ...prev,
      [emp.value]: !prev[emp.value],
    }));

    setFormData((prev) => {
      let arr = prev.attendees ? prev.attendees.split(",") : [];
      arr = arr.filter((x) => x); 
      const exists = arr.includes(String(emp.value));

      if (exists) {
        arr = arr.filter((id) => id !== String(emp.value));
      } else {
        arr.push(String(emp.value));
      }

      return {
        ...prev,
        attendees: arr.join(","),
      };
    });
  };


  const selectAll = (e) => {
    const checked = e.target.checked;

    if (checked) {
      const ids = employees.map((emp) => String(emp.value));

      const map = {};
      ids.forEach((id) => (map[id] = true));

      setSelectedMap(map);

      setFormData((prev) => ({
        ...prev,
        attendees: ids.join(","),
      }));
    } else {
      setSelectedMap({});
      setFormData((prev) => ({
        ...prev,
        attendees: "",
      }));
    }
  };

  const selectedEmployees = employees.filter((e) => selectedMap[e.value]);

  return (
    <div className="container-fluid" style={{ overflow: "hidden" }}>
      <div className="row">
        <div className="col-12">
          <div className="row mb-3 mt-2">
            <div className="col-4">
              <Input
                placeholder="Search"
                allowClear
                value={search}
                onChange={storeSearch}
                prefix={<SearchOutlined />}
              />
            </div>

            <div className="col-4 d-flex justify-content-center align-items-center">
              <Checkbox
                onChange={selectAll}
                checked={
                  employees.length > 0 &&
                  employees.every((emp) => selectedMap[emp?.value])
                }
              >
                Select All
              </Checkbox>
            </div>

            <div className="col-4 d-flex justify-content-center">
              <div className="d-flex gap-1 align-items-center ">
                <img src={attendeesimg} style={{ width: "30px" }} />
                <p
                  style={{
                    color: "red",
                    fontWeight: 700,
                    fontSize: "20px",
                    marginBottom: 0,
                  }}
                >
                  {selectedEmployees.length}
                </p>
              </div>
            </div>
          </div>

          <div
            style={{
              maxHeight: "340px",
              overflowY: "auto",
              overflowX: "hidden",
              // border: "1px solid #eee",
              borderRadius: "6px",
              // padding: "10px",
              paddingBottom: "10vh",
            }}
          >
            <div className="row">
              {filtered.map((emp) => {
                const isChecked = !!selectedMap[emp.value];

                return (
                  <div className="col-4 mb-2" key={emp.value}>
                    <div
                      className="d-flex align-items-center p-2"
                      style={{
                        cursor: "pointer",
                        border: "1px solid #f1f1f1",
                        borderRadius: "6px",
                        background: isChecked ? "#f0f8ff" : "",
                      }}
                      onClick={() => toggleEmployee(emp)}
                    >
                      <Checkbox
                        checked={isChecked}
                        style={{ marginRight: "6px" }}
                      />

                      <div style={{ marginRight: "8px" }}>
                        <GetImage
                          key={emp.value}
                          redirect={false}
                          width="30px"
                          height="30px"
                          imgID={emp.value}
                        />
                      </div>
                      <span style={{ fontSize: "14px" }}>{emp.label}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}